export const HEADERS = [
  { label: "รหัสคำขอ", key: "requestNo" },
  { label: "รหัสการซ่อม", key: "maintainId" },
  { label: "หมายเลขเครื่องตัด", key: "deviceId" },
  { label: "รหัสลูกค้า", key: "customerCode" },
  { label: "ชื่อลูกค้า", key: "customerName" },
  { label: "วันที่แจ้ง", key: "createDate" },
  { label: "รหัสเซลล์", key: "saleCode" },
  { label: "ผู้ที่แจ้ง", key: "userCreate" },
  { label: "รายละเอียด", key: "description" },
  { label: "ซ่อม / เคลม", key: "maintainType" },
  { label: "สถานะ", key: "maintainStatus" },
  { label: "วันที่ซ่อมเสร็จ", key: "repairCompleteDate" },
  { label: "ช่างที่ซ่อม", key: "repairman" },
  { label: "วันที่กรอก Tracking", key: "trackingDate" },
  { label: "ประเภท Tracking", key: "deliveryName" },
  { label: "หมายเลข Tracking", key: "trackingNo" },
  { label: "คนที่กรอก Tracking", key: "trackingBy" },
];
